import { useState, useCallback } from "react";
import { UserInfoDomain } from "@/types/UserInfo";
import { UserSubscriptionDomain } from "@/types/UserSubscription";
import { userInfoRepository } from "@/services/userInfoRepository";

export const useDataManagement = () => {
  const [userInfo, setUserInfo] = useState<UserInfoDomain | null>(null);
  const [subscription, setSubscription] = useState<UserSubscriptionDomain | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { getHomeInfo, getUserSubscription, getUserInfo, getConfig } = userInfoRepository;

  const updateUserInfo = useCallback(async () => {
    try {
      const response = await getUserInfo();
      setUserInfo(response);
      return response;
    } catch (error) {
      console.error("Error updating user info:", error);
    }
  }, [getUserInfo]);

  const updateSubscriptionInfo = useCallback(async (): Promise<boolean> => {
    try {
      const response = await getUserSubscription();
      setSubscription(response);
      return response?.isSubscribed ?? false;
    } catch (error) {
      console.error("Error updating subscription:", error);
      return false;
    }
  }, [getUserSubscription]);

  const updateHomeInfo = useCallback(async () => {
    try {
      const response = await getHomeInfo();
      const config = await getConfig();
      const isSubscribed = await updateSubscriptionInfo();
      await updateUserInfo();
      return { response, isSubscribed, config };
    } catch (error) {
      console.error("Error updating home info:", error);
      return { response: null, isSubscribed: false, config: null };
    }
  }, [getHomeInfo, updateSubscriptionInfo, updateUserInfo, getConfig]);

  return {
    userInfo,
    subscription,
    isLoading,
    setIsLoading,
    updateHomeInfo,
  };
}; 